module.exports = __webpack_public_path__ + "static/media/in-house.687d1df4.png";